import { hideModal, initCloseButtons, initFlashes, initForms, showModal } from "./functions";
import bulmaCalendar from '../node_modules/bulma-calendar/dist/js/bulma-calendar.min.js';

function closeAllOpenedSections() {
	const sections = Array.prototype.slice.call(document.getElementsByClassName("reveal-section"), 0);
	sections.forEach((el: HTMLElement) => {
		el.style.display = "none";
		el.classList.remove("opened");
	});

	const buttons = Array.prototype.slice.call(document.getElementsByClassName("reveal-button"), 0);
	buttons.forEach((el: HTMLElement) => {
		const children = Array.prototype.slice.call(el.children, 0);
		children.forEach((ch: HTMLElement) => {
			if (ch.tagName === "IMG") {
				ch.style.transform = "none";
			}
		});
		const text = <HTMLElement>el.children[0];
		el.classList.remove("opened");

		if (el.dataset.closedText) {
			text.textContent = el.dataset.closedText;
		}
	});
}

function hideAllActiveModals() {
	// Hide all active modals
	const activeModals = Array.prototype.slice.call(document.querySelectorAll(".modal.is-active"), 0);
	activeModals.forEach((el: HTMLDivElement) => {
		hideModal(el.id);
	});
}

document.addEventListener("DOMContentLoaded", () => {
	const contactButton = Array.prototype.slice.call(document.querySelectorAll(".open-modal"), 0);
	contactButton.forEach((el: HTMLButtonElement) => {
		el.addEventListener("click", () => {
			// Hide all active modals
			hideAllActiveModals();

			// Hide all home details
			const homes = Array.prototype.slice.call(document.querySelectorAll("[id^=home]"), 0);
			homes.forEach((el: HTMLDivElement) => {
				el.style.display = "none";
			});

			// Open new modal
			const modalID = el.dataset.modal ? el.dataset.modal : "";
			showModal(modalID);

			// Prefill home in radio list
			const home = el.dataset.home ? el.dataset.home : null;
			if (home !== null) {
				const h = <HTMLInputElement>document.querySelector("input[name='home'][value='" + home + "']");
				h.checked = true;
			} else {
				const h = Array.prototype.slice.call(document.querySelectorAll("input[name='home']"), 0);
				h.forEach((el: HTMLInputElement) => {
					el.checked = false;
				});
			}

			// Show home detail
			const homeDetail = el.dataset.homeDetail ? el.dataset.homeDetail : null;
			if (homeDetail !== null) {
				const d = <HTMLInputElement>document.getElementById("home" + homeDetail);
				d.style.display = "block";
			}
		});
	});

	const countdown = document.getElementById("countdown");
	if (countdown?.dataset.days) {
		let days = parseInt(countdown?.dataset.days) || null;
		if (days !== null && days <= 0) {
			countdown.style.display = "none";
			const kittensCountdown = document.getElementById("kittens-countdown");
			if (kittensCountdown) {
				kittensCountdown.style.alignSelf = "end";
			}
		}
	}

	const modalBackgrounds = Array.prototype.slice.call(document.getElementsByClassName("modal-background"), 0);
	modalBackgrounds.forEach((el: HTMLElement) => {
		el.addEventListener("click", () => {
			hideAllActiveModals();
		});
	});

	const reservationButton = document.getElementById("reservation-agree-button");
	reservationButton?.addEventListener("click", () => {
		const info = document.getElementById("reservation-info");
		const form = document.getElementById("reservation-form");
		if (info !== null) {
			info.style.display = "none";
		}
		if (form !== null) {
			form.style.display = "block";
		}
	});

	const sittingButton = document.getElementById("sitting-agree-button");
	sittingButton?.addEventListener("click", () => {
		const info = document.getElementById("sitting-info");
		const form = document.getElementById("sitting-form");
		if (info !== null) {
			info.style.display = "none";
		}
		if (form !== null) {
			form.style.display = "block";
		}
	});

	const reveals = Array.prototype.slice.call(document.getElementsByClassName("reveal-button"), 0);
	reveals.forEach((el: HTMLDivElement) => {
		el.addEventListener("click", () => {
			if (!el.classList.contains("opened")) {
				closeAllOpenedSections();
				const children = Array.prototype.slice.call(el.children, 0);
				children.forEach((ch: HTMLElement) => {
					if (ch.tagName === "IMG") {
						ch.style.transform = "rotate(270deg)";
					}
				});
				const text = <HTMLElement>el.children[0];
				const reveal = <HTMLElement>el.nextElementSibling;
				if (el.dataset.openedText) {
					text.textContent = el.dataset.openedText;
				}
				reveal.style.display = "block";

				el.classList.add("opened");
				reveal.classList.add("opened");
			} else {
				closeAllOpenedSections();
			}
		});
	});
});

let now = new Date();
now.setMinutes(0);
// Initialize all input of date type.
const calendars = bulmaCalendar.attach('[type="date"]', {
	color: "primary",
	type: "datetime",
	lang: "cs",
	dateFormat: "d.M.yyyy",
	timeFormat: "HH:mm",
	displayMode: "dialog",
	showTodayButton: false,
	showClearButton: false,
	cancelLabel: "Zrušit",
	validateLabel: "Vybrat datum a čas",
	closeOnSelect: false,
	minDate: new Date(),
	startDate: new Date(),
	startTime: now,
	weekStart: 1,
	minuteSteps: 15
	//editTimeManually: true
});

initFlashes();
initCloseButtons();
initForms();
